import { BaseApi } from "../services/BaseApi";
import { TOKEN_TYPE, ENVIRONMENT, TOKEN_RESPONSE } from "../utils/Constant";
import ResponseCode from "../services/ResponseCode";

const refreshTokenURL = "api/v1/websalud/primeraars/auth/refresh-token";

export const InterceptToken = async (
  httpRequest,
  url,
  params = null,
  aditionalHeaders = null
) => {
  let responseOriginal = await httpRequest(url, params, {
    headers: aditionalHeaders,
  });

  if (
    responseOriginal?.data?.respuesta?.mensaje ===
    TOKEN_RESPONSE.access_token_expirado
  ) {
    // Refrescar el token y volver a intentar el llamado original
    const responseNewAccessToken = await BaseApi.post(refreshTokenURL, {
      compania: process.env.REACT_APP_COMPANY,
    });

    if (
      responseNewAccessToken.data?.respuesta?.mensaje ===
      TOKEN_RESPONSE.refresh_token_valido
    ) {
      const { accessToken } = responseNewAccessToken?.data?.data;

      responseOriginal.config.headers.Authorization = `${TOKEN_TYPE.BEARER} ${accessToken}`;
      // Llamada al servicio original
      responseOriginal = await BaseApi.axiosInstance(responseOriginal.config);

      if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.development) {
        console.log(responseOriginal);
      }

      return responseOriginal;
    }

    if (
      responseNewAccessToken?.data?.respuesta?.mensaje ===
      TOKEN_RESPONSE.refresh_token_invalido
    ) {
      window.location.replace("/logout");
    }
  }

  if (responseOriginal?.status === ResponseCode.UNAUTHORIZED.code) {
    window.location.replace("/logout");

    return {
      ...responseOriginal,
      data: {
        respuesta: {
          codigo: ResponseCode.UNAUTHORIZED.code,
          mensaje: "La sesión ha expirado",
        },
      },
    };
  }

  return responseOriginal;
};
